import { Div, Line, Link, Span } from "@tblabs/truffle";
import { PackageToCustomerStepData } from "../Models/PackageToCustomerStepData";


export class PackageTracker extends Div
{
    constructor(data: PackageToCustomerStepData)
    {
        super();
        this.MarginTop(16)

        const carrier = data.Carrier.value.trim().toLowerCase();

        switch (carrier)
        {
            case "pocztex":
                this.Append(
                    new Link("🗺️ Śledzenie paczki", `https://www.pocztex.pl/sledzenie-przesylek/?numer=${data.PackageNumber.value}`).OpenInNewCard()
                );
                break;
            case "dhl":
                this.Append(
                    new Link("🗺️ Śledzenie paczki", `https://www.dhl.com/pl/pl/home/tracking.html?trackingNumber=${data.PackageNumber.value}`).OpenInNewCard()
                );
                break;
            default:
                this.Append(new Span("Brak danych na temat śledzenia paczki").Italic());
                break;
        }

        this.Append(
            new Line(),
            "Numer paczki: ", data.PackageNumber.value,
            "\nPrzewoźnik: ", carrier);
    }
}
